import * as z from 'zod';

// Details step data – matches spec in LLM_IN_PROGRESS.md section 4.
export const waitlistDetailsSchema = z.object({
  givenName: z.string().min(2, 'Required'),
  familyName: z.string().min(2, 'Required'),
  email: z.string().email(),
});

export type WaitlistDetails = z.infer<typeof waitlistDetailsSchema>;
